<template>
  <a-spin :spinning="loadState" tip="Loading..." size="large">
    <div class="login-box">
      <div class="logo">
        <img src="./img/denglogo.png" />
      </div>
      <div class="logo-deng">
        <img src="./img/dengbottom.png" />
      </div>
      <div class="input-wrap">
        <img src="./img/deuser.png" class="input-img" />
        <input
          type="text"
          autocapitalize="off"
          v-model="username"
          :placeholder="$t('loginPage.namePlaceholder')"
        />
      </div>
      <div class="input-wrap input-wrap02">
        <img src="./img/delock.png" class="input-img" />
        <input
          type="password"
          v-model="password"
          :placeholder="$t('loginPage.passPlaceholder')"
        />
        <span class="forget-psw" @click="forgetPassword">{{
          $t("loginPage.forget")
        }}</span>
      </div>
      <div class="hint-error">
        <p class="hint-text" v-show="errorHint">
          <a-icon type="exclamation-circle" theme="filled" class="icon" />
          {{ errorHint }}
        </p>
      </div>

      <div class="login-btn" @click="send()">{{ $t("loginPage.login") }}</div>
    </div>
  </a-spin>
</template>
<script>
import encrypt from "@/lib/encrypt";

export default {
  data() {
    return {
      username: "",
      password: "",
      errorHint: null,
      // 加载状态
      loadState: false,
    };
  },
  mounted() {
    document.title = this.$i18n.locale === "zh" ? "登录" : "Login";
    if (this.$route.query.user_id) {
      localStorage.setItem("_user_data_id", this.$route.query.user_id);
      localStorage.setItem(
        "_user_data_company_id",
        this.$route.query.company_id
      );
      localStorage.setItem("_sys_id", "5");
      localStorage.setItem("_user_data_sso_token", this.$route.query.sso_token);
      localStorage.setItem("_user_data_language", "zh-cn");
    }
    if (this.$route.query.etype) {
      var errorMsg = null;
      if (this.$route.query.etype == 404) {
        errorMsg = "抱歉，这个页面已经被外星人绑架了！";
      } else if (this.$route.query.etype == 502) {
        errorMsg = "哎呀，服务器暂时无法通行，请稍后重试";
      } else if (this.$route.query.etype == 0) {
        errorMsg = this.$route.query.msg;
      }
      this.$router.replace({
        path: "/main/error",
        query: {
          msg: errorMsg,
        },
      });
    }
    if (localStorage._user_data_sso_token) {
      // 如果不是通过登录页进入
      if (sessionStorage.fromUrl) {
        this.$router.replace({ path: sessionStorage.fromUrl });
        sessionStorage.removeItem("fromUrl");
      } else {
        this.$router.replace("main/index");
      }
    }
  },
  methods: {
    send() {
      if (this.username == "") {
        this.$toast(
          `<p style='width: 3rem;'>${this.$t("loginPage.nullName")}</p>`
        );
      } else if (this.password == "") {
        this.$toast(
          `<p style='width: 3rem;'>${this.$t("loginPage.nullPassword")}</p>`
        );
      } else {
        const strNum = new Date().getTime() * 1000;
        this.loadState = true;
        var _this = this;
        let url = "index.php/mobile/index/login";
        let params = {
          username: this.username,
          k: encrypt.getRsaCode(strNum),
          pwd: encrypt.getAesCode(this.password, strNum),
          sys_id: 5,
          // 开发环境
          // company_code: "intest",
          // 打包代码
          company_code: window.location.origin.split(".")[0].split("//")[1],
        };
        this.$axios
          .post(url, { ...params })
          .then((res) => {
            this.loadState = false;
            var data = res.data;
            if (data.code == 0) {
              localStorage.setItem("_user_data_id", data.result.id);
              localStorage.setItem("_sys_id", "5");
              localStorage.setItem(
                "_user_data_company_id",
                data.result.company_id
              );
              localStorage.setItem(
                "_user_data_department_id",
                data.result.department_id
              );
              localStorage.setItem(
                "_user_data_sso_token",
                data.result.sso_token
              );
              if (data.result.default_language) {
                localStorage._user_data_language = data.result.default_language;
                data.result.default_language.includes("en")
                  ? (this.$i18n.locale = "en")
                  : (this.$i18n.locale = "zh");
              }
              localStorage.setItem(
                "_platform_have_modules",
                data.result.modules
              );
              localStorage.setItem(
                "_platform_home_modules",
                data.result.home_custom_modules
              );
              localStorage.setItem("_name", data.result.name);
              localStorage.setItem("_username", data.result.username);
              localStorage.setItem("date", new Date().toLocaleDateString());
              // 如果不是通过登录页进入
              if (
                sessionStorage.fromUrl &&
                sessionStorage.fromUrl != "/login"
              ) {
                // let routePath;
                // let queryData;
                // if(sessionStorage.fromUrl.includes('?')){
                //   routePath = sessionStorage.fromUrl.split("?")[0];
                //   queryData = `?${sessionStorage.fromUrl.split("?")[1]}`;
                //   queryData = JSON.parse(`{${queryData.replace("?", "\"").replace(new RegExp(/(&)/g),'\",\"').replace(new RegExp(/(=)/g),'\":\"')}"}`);
                // }else{
                //   routePath = sessionStorage.fromUrl
                //   queryData = {}
                // }
                // this.$router.replace({path: routePath,query: queryData});

                if (sessionStorage.fromUrl.substr(0, 4) == "http") {
                  window.location.href = sessionStorage.fromUrl;
                } else {
                  this.$router.replace({ path: sessionStorage.fromUrl });
                }
                sessionStorage.removeItem("fromUrl");
              } else {
                _this.$router.replace("/main/index");
              }
            } else {
              //  console.log("用户不存在")
              this.errorHint = data.msg;
            }
          })
          .catch(() => {
            this.loadState = false;
          });
      }
    },
    // 忘记密码
    forgetPassword() {
      this.$router.push({ name: "forgetPassword" });
    },
  },
};
</script>
<style scoped lang="less">
@import "~@/assets/sass/color.less";
.login-box {
  width: 7.5rem;
  height: 100%;
  background: url("./img/bgtip.jpg") repeat top;
  font-size: 0.22rem;
  overflow: hidden;
  min-height: 100vh;
  position: relative;
  // z-index: -5;
  .logo {
    height: 0.84rem;
    position: absolute;
    left: 0.5rem;
    top: 0.42rem;
    img {
      height: 100%;
      width: auto;
    }
  }
  .logo-deng {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 5.26rem;
    // z-index: 0;
    img {
      height: 100%;
    }
  }
  .hint-error {
    height: 0.4rem;
  }
  .hint-text {
    color: @unPassColor;
    margin-left: 0.6rem;
    .icon {
      margin-right: 0.1rem;
      font-size: 0.24rem;
    }
  }
}
.input-wrap {
  background: white;
  width: 6.5rem;
  height: 0.9rem;
  line-height: 0.9rem;
  border: 1px solid #bababa;
  border-radius: 0.08rem;
  margin: 0 auto;
  margin-top: 2.56rem;
  display: flex;
  position: relative;
  overflow: hidden;
  input {
    flex: 1;
    outline: none;
    border: none;
    padding-left: 1rem;
    padding-right: 0.1rem;
    font-size: 0.26rem;
    line-height: 0.4rem;
    &::-webkit-input-placeholder {
      /* placeholder颜色  */
      color: #aaa;
    }
  }
  .input-img {
    height: 100%;
    width: auto;
    position: absolute;
    left: 0;
    top: 0;
  }
  .forget-psw {
    margin-right: 0.2rem;
    color: #bababa;
  }
}
.input-wrap02 {
  margin-top: 0.3rem;
}
.login-btn {
  width: 6.5rem;
  height: 0.9rem;
  line-height: 0.9rem;
  border-radius: 0.08rem;
  margin: 0 auto;
  margin-top: 2.56rem;
  overflow: hidden;
  background-image: url("./img/debtn.png");
  background-size: cover;
  font-size: 0.3rem;
  color: white;
  text-align: center;
  margin-top: 0.7rem;
  position: relative;
  z-index: 99;
}
</style>
